export default "__VITE_ASSET__a94f9ec5__"